import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionHandlerService } from 'src/app/views/login/commons/services/session-handler.service';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {

  constructor(private session: SessionHandlerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const auth = this.session.getAuthToken();
    if (auth) {
      request = request.clone({
        setHeaders: {
          'content-type': 'application/json',
          Authorization: `${auth.token_type} ${ auth.access_token }`
        }
      });
    }
    return next.handle(request);
  }
}
